import { FC, useContext } from "react";
import FormFieldsContainer from "../../../../components/ui/FormFieldsContainer";
import { Form, ModalDialog } from "@rothoblaas/design-system";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../context/notificationContext";
import useI18n from "../../../../hooks/useTranslations";
import {
  ConnectorMaterial,
  InsertConnectorMaterialBody,
  UpdateConnectorMaterialBody,
} from "../../../../http/deckDesigner/types/connectorMaterials";
import useDeckConnectorMaterialsApi from "../../../../http/deckDesigner/useConnectorMaterials";
import TranslatableTextField from "../../../../components/ui/TranslatableTextField";

interface ConnectorMaterialFormBody {
  name: string | null;
  nameIt: string | null;
  nameDe: string | null;
  nameEs: string | null;
  nameFr: string | null;
}

interface ConnectorMaterialFormProps {
  connectorMaterial?: ConnectorMaterial;
  onClose: () => void;
}

const ConnectorMaterialForm: FC<ConnectorMaterialFormProps> = ({ connectorMaterial, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const connectorMaterialsApi = useDeckConnectorMaterialsApi();

  const defaultValues: ConnectorMaterialFormBody = {
    name: connectorMaterial?.name ?? null,
    nameIt: connectorMaterial?.nameIt ?? null,
    nameDe: connectorMaterial?.nameDe ?? null,
    nameEs: connectorMaterial?.nameEs ?? null,
    nameFr: connectorMaterial?.nameFr ?? null,
  };

  const onSubmit = () => async (formData: ConnectorMaterialFormBody) => {
    const body: InsertConnectorMaterialBody | UpdateConnectorMaterialBody = {
      name: formData.name ?? "",
      nameIt: formData.nameIt || null,
      nameDe: formData.nameDe || null,
      nameEs: formData.nameEs || null,
      nameFr: formData.nameFr || null,
    };

    try {
      if (connectorMaterial) {
        await connectorMaterialsApi.updateDeckConnectorMaterial(connectorMaterial.id, body);
      } else {
        await connectorMaterialsApi.insertDeckConnectorMaterial(body);
      }
      dispatch(showSuccessNotification(i18n.translation));
      onClose();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <ModalDialog
      onClose={onClose}
      title={
        connectorMaterial
          ? `${i18n.translation.common.edit} ${i18n.translation.deckDesignerModule.connectorMaterials.singular}`
          : `${i18n.translation.common.add} ${i18n.translation.deckDesignerModule.connectorMaterials.singular}`
      }
    >
      <Form<ConnectorMaterialFormBody>
        submitText={i18n.translation.common.save}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
      >
        {(form) => (
          <FormFieldsContainer fullWidth>
            <TranslatableTextField form={form} />
          </FormFieldsContainer>
        )}
      </Form>
    </ModalDialog>
  );
};

export default ConnectorMaterialForm;
